import React, { FC } from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import { Item } from './Item';

export const SortableItem: FC<any> = (props: any) => {
  const sortableProps: any = {id: props.id}
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable(sortableProps);
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    'touchAction': 'auto',
  };
  
  return (
    <Item ref={setNodeRef} style={style} {...attributes} {...listeners} id={props.id}>
      {props.children}
    </Item>
  );
}